import React from "react";
import SEOLandingPage from "./SEOLandingPage";

const AiMarkdownNotesAndroid: React.FC = () => (
  <SEOLandingPage
    title="AI Markdown Notes for Android — Mermaid Diagrams & CLAUDE.md | Cosmovex"
    metaDescription="AgentPager's Toolkit is a markdown workspace for Android. Write notes and docs in Markdown with live preview, render Mermaid diagrams, build CLAUDE.md and agent files, and keep a prompt vault."
    ogTitle="AI Markdown Notes for Android — Markdown, Mermaid & Agent Files in One App"
    h1="AI Markdown Notes & Docs for Android"
    intro="A markdown workspace built for the AI era. Write notes, docs and READMEs with live preview, render Mermaid diagrams as you type, and keep your CLAUDE.md and agent files in shape."
    paragraphs={[
      "Markdown is where modern dev work lives — READMEs, specs, meeting notes, and now the AI-facing files like CLAUDE.md, AGENTS.md and rule files that steer coding assistants. AgentPager's Toolkit treats all of it as first-class: a clean split editor with syntax highlighting on one side, a polished live preview on the other, and templates for the files AI developers write every day. The markdown workspace is the Toolkit section of AgentPager, the Android app that also pages you when a coding agent on your computer needs a decision.",
      "Mermaid diagrams render live. Type Mermaid code for a flowchart, sequence diagram, or ERD inside any document and watch it draw itself in the preview — no separate diagram app, no exporting images back and forth. It's the quickest way to sketch architecture in a note on your phone.",
      "Agent files get their own treatment. A guided builder assembles CLAUDE.md and AGENTS.md section by section, so the instructions your coding assistant reads stay tidy. Draft one on the bus, tighten the wording while it's fresh in your mind, or review a rule file away from your desk.",
      "A built-in prompt vault keeps your best prompts tagged and ready to reuse, and the LAN vault server hands your documents to a machine on your own network when you want them off the phone. Everything works offline — free to download, no account needed to start writing.",
    ]}
    features={[
      "Markdown editor with syntax highlighting & live preview",
      "Mermaid diagrams render live — flowcharts, sequences, ERDs",
      "Builder for CLAUDE.md, AGENTS.md and agent rule files",
      "Prompt vault with tags and variables",
      "LAN vault server for your own network",
      "Part of AgentPager — pages you when an agent needs a decision",
      "Works offline",
      "No account needed, free to download",
    ]}
    playStoreUrl="https://play.google.com/store/apps/details?id=com.cosmovex.mdpilot"
    icon="/images/play/mdpilot.png"
    appName="AgentPager"
    accentColor="#A8720E"
    canonicalPath="/ai-markdown-notes-android"
  />
);

export default AiMarkdownNotesAndroid;
